import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import notificationService from '../../services/notificationService';
import {
  fetchNotificationsRequest,
  fetchNotificationsSuccess,
  fetchNotificationsFailure,
  fetchNotificationCountRequest,
  fetchNotificationCountSuccess,
  fetchNotificationCountFailure,
  markAsReadRequest,
  markAsReadSuccess,
  markAsReadFailure,
  markAllAsReadRequest,
  markAllAsReadSuccess,
  markAllAsReadFailure,
  deleteNotificationRequest,
  deleteNotificationSuccess,
  deleteNotificationFailure,
} from './slice';

function* fetchNotificationsSaga(action) {
  try {
    const response = yield call(notificationService.getNotifications, action.payload);
    yield put(fetchNotificationsSuccess(response));
  } catch (error) {
    yield put(fetchNotificationsFailure(error.message || 'Failed to fetch notifications'));
  }
}

function* fetchNotificationCountSaga() {
  try {
    const response = yield call(notificationService.getNotificationCount);
    yield put(fetchNotificationCountSuccess(response));
  } catch (error) {
    yield put(fetchNotificationCountFailure(error.message || 'Failed to fetch notification count'));
  }
}

function* markAsReadSaga(action) {
  try {
    console.log('markAsReadSaga: Marking notification as read, id:', action.payload);
    const response = yield call(notificationService.markAsRead, action.payload);
    console.log('markAsReadSaga: Success response:', response);
    yield put(markAsReadSuccess());
    // Refresh count and list after marking as read to ensure persistence
    yield put(fetchNotificationCountRequest());
    // Refresh notifications list to get updated read status
    yield put(fetchNotificationsRequest({ page: 1, pageSize: 20 }));
  } catch (error) {
    console.error('markAsReadSaga: Error:', error);
    yield put(markAsReadFailure(error.message || 'Failed to mark notification as read'));
    // Refresh to revert optimistic update
    yield put(fetchNotificationsRequest({ page: 1, pageSize: 20 }));
  }
}

function* markAllAsReadSaga() {
  try {
    yield call(notificationService.markAllAsRead);
    yield put(markAllAsReadSuccess());
    // Refresh count and list after marking all as read to ensure persistence
    yield put(fetchNotificationCountRequest());
    // Refresh notifications list to get updated read status
    yield put(fetchNotificationsRequest({ page: 1, pageSize: 20 }));
  } catch (error) {
    yield put(markAllAsReadFailure(error.message || 'Failed to mark all notifications as read'));
    // Refresh to revert optimistic update
    yield put(fetchNotificationsRequest({ page: 1, pageSize: 20 }));
  }
}

function* deleteNotificationSaga(action) {
  try {
    console.log('deleteNotificationSaga: Deleting notification, id:', action.payload);
    const response = yield call(notificationService.deleteNotification, action.payload);
    console.log('deleteNotificationSaga: Success response:', response);
    yield put(deleteNotificationSuccess(action.payload));
    // Refresh count after deleting
    yield put(fetchNotificationCountRequest());
    // Refresh notifications list to ensure UI is in sync
    yield put(fetchNotificationsRequest({ page: 1, pageSize: 20 }));
  } catch (error) {
    console.error('deleteNotificationSaga: Error:', error);
    yield put(deleteNotificationFailure(error.message || 'Failed to delete notification'));
    // Refresh to revert optimistic update
    yield put(fetchNotificationsRequest({ page: 1, pageSize: 20 }));
  }
}

export function* watchNotificationActions() {
  yield takeLatest(fetchNotificationsRequest.type, fetchNotificationsSaga);
  yield takeEvery(fetchNotificationCountRequest.type, fetchNotificationCountSaga);
  yield takeEvery(markAsReadRequest.type, markAsReadSaga);
  yield takeEvery(markAllAsReadRequest.type, markAllAsReadSaga);
  yield takeEvery(deleteNotificationRequest.type, deleteNotificationSaga);
}

